import React from 'react';
import { ErrorSmall } from '@wix/wix-ui-icons-common/on-stage';
import { Text, TextButton, Popover } from 'wix-ui-tpa/cssVars';
import { st, classes } from '../FileUpload.st.css';
import { DATA_HOOKS } from '../dataHooks';
import File from './File';
const FileUploadPopover = _ref => {
  let {
    files,
    onDeleteClick,
    deleteText,
    explanationText,
    hasError,
    setTextBelowButtonRef
  } = _ref;
  const [showFiles, setShowFiles] = React.useState(false);
  return /*#__PURE__*/React.createElement(Popover, {
    placement: "bottom",
    onClickOutside: () => setShowFiles(false),
    shown: showFiles,
    className: classes.popover,
    width: 280
  }, /*#__PURE__*/React.createElement(Popover.Element, null, /*#__PURE__*/React.createElement(TextButton, {
    "data-hook": DATA_HOOKS.popoverButton,
    className: st(classes.multipleFileExplanation, {
      error: hasError
    }),
    onClick: () => setShowFiles(!showFiles),
    ref: setTextBelowButtonRef
  }, explanationText)), /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement("div", {
    "data-hook": DATA_HOOKS.popoverContent,
    className: classes.files
  }, (files != null ? files : []).map((file, index) => /*#__PURE__*/React.createElement("div", {
    className: classes.multipleFiles,
    key: file.file.name,
    "data-hook": DATA_HOOKS.popoverFile
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(File, {
    file: file,
    onDeleteClick: () => onDeleteClick == null ? void 0 : onDeleteClick(index),
    deleteText: deleteText,
    dataHook: DATA_HOOKS.popoverFileName,
    focusFile: true,
    "aria-describedby": file.file.name + "-error"
  }), file.errorMessage && /*#__PURE__*/React.createElement("div", {
    className: classes.fileError,
    "data-hook": DATA_HOOKS.popoverFileError
  }, /*#__PURE__*/React.createElement(ErrorSmall, {
    className: classes.fileErrorIcon
  }), /*#__PURE__*/React.createElement(Text, {
    id: file.file.name + "-error",
    className: classes.filesErrorMessage
  }, file.errorMessage))))))));
};
export default FileUploadPopover;
//# sourceMappingURL=FileUploadPopover.js.map